"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)({
  chip: {
    marginLeft: 8,
    cursor: 'pointer',
    '&:first-child': {
      marginLeft: 0
    }
  }
}, {
  name: 'RadioButton'
});
exports.useStyles = useStyles;